import arrow from "../../assets/icons/arrow.svg";

export interface SeeMoreProps {
  onSeeMore: () => void;
}

export default function SeeMore(props: SeeMoreProps) {
  return (
    <button
      onClick={props.onSeeMore}
      className="flex flex-row items-center ~py-0.5/1 hover:scale-110 duration-250"
    >
      <div className="font-archb ~text-xxs/xs bg-gradient-to-b from-mango to-crail bg-clip-text text-transparent">
        ...SEE MORE
      </div>
      <img src={arrow} className="~pl-1/1.5 ~h-1.5/2" alt="arrow" />
    </button>
  );
}
